
interface ApiConfig {
  API_URL: string;
}

interface AppConfig {
  PANEL_URL: string;
  ASSET_URL: string;
}

interface Config {
  api: ApiConfig;
  app: AppConfig;
}

const trimTrailingSlash = (value?: string) => (value || "").replace(/\/+$/, "");

const apiUrl = trimTrailingSlash(process.env.REACT_APP_API_URL);
const panelUrl = trimTrailingSlash(
  process.env.REACT_APP_PANEL_URL ||
  process.env.REACT_APP_COMPANY_DOMAIN
);
const assetUrl = trimTrailingSlash(
  process.env.REACT_APP_ASSET_URL ||
  process.env.REACT_APP_API_URL
);

const config: Config = {
  api: {
    API_URL: apiUrl,
  },
  app: {
    PANEL_URL: panelUrl,
    ASSET_URL: assetUrl,
  },
};

export const buildAssetUrl = (path: string) => {
  const cleanPath = path.replace(/^\/+/, "");
  return config.app.ASSET_URL ? `${config.app.ASSET_URL}/${cleanPath}` : `/${cleanPath}`;
};

export default config;
